/**
 * Premium plan preview page – Navbar + ArtistPremiumProfile + Footer.
 */

import React from "react";
import { Navbar } from "@/templates/Navbar";
import { Footer } from "@/templates/Footer";
import ArtistPremiumProfile from "./Premium/ArtistPremiumProfile";

export interface PremiumPreviewProps {
  isMobile?: boolean;
}

export default function PremiumPreview({ isMobile = false }: PremiumPreviewProps) {
  return (
    <div className="text-white">
      {/* <Navbar /> */}
      <ArtistPremiumProfile isMobile={isMobile} />
      <Footer />
    </div>
  );
}
